import React, { useEffect, useState } from "react";
import { Card, CardContent, Typography, Grid, Box } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import DevicesIcon from "@mui/icons-material/Devices";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import MemoryIcon from "@mui/icons-material/Memory";
import BusinessIcon from "@mui/icons-material/Business";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import { GetDashboardData } from "../Api";

interface MetricCardProps {
  title: string;
  value: number;
  icon: React.ReactNode;
}

const MetricCard: React.FC<MetricCardProps> = ({ title, value, icon }) => {
  return (
    <Card elevation={3}>
      <CardContent>
        <Box display="flex" alignItems="center">
          <Box mr={2}>{icon}</Box>
          <Box>
            <Typography variant="h6">{title}</Typography>
            <Typography variant="h5" fontWeight="bold">
              {value}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export const Dashboard: React.FC = () => {
  const [dashboardData, setDashboardData] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await GetDashboardData();
        setDashboardData(res);
      } catch (err) {
        console.error("Failed to fetch dashboard data", err);
      }
    };

    fetchData();
  }, []);
  // Simulated data — replace with actual data from props/API as needed
  const metrics = [
    {
      title: "Total Users",
      value: dashboardData?.managerUsers ?? 0,
      icon: <PeopleIcon fontSize="large" color="primary" />,
    },
    {
      title: "Total Connected Devices",
      value: dashboardData?.connectedDevicesCount ?? 0,
      icon: <CheckCircleIcon fontSize="large" color="success" />,
    },
    {
      title: "Total Devices",
      value: dashboardData?.allDevices ?? 0,
      icon: <DevicesIcon fontSize="large" color="action" />,
    },

    {
      title: "Total Organizations",
      value: dashboardData?.orgCount ?? 0,
      icon: <BusinessIcon fontSize="large" color="info" />,
    },
    {
      title: "Total Projects",
      value: dashboardData?.projectsCount ?? 0,
      icon: <WorkspacesIcon fontSize="large" color="secondary" />,
    },
  ];

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Dashboard
      </Typography>
      <Grid container spacing={3}>
        {metrics.map((metric, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <MetricCard
              title={metric.title}
              value={metric.value}
              icon={metric.icon}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
